export const NOTIFICATION_SETUP_BANNER_STATE_EVENT =
  "sell-it-off:notification-setup-banner-state-changed";

export function dispatchNotificationSetupBannerStateChanged(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(NOTIFICATION_SETUP_BANNER_STATE_EVENT));
}
